import { useEffect } from "react";
import Banner from "../components/About/Banner";
import WhoWe from "../components/About/WhoWe";
import Funds from "../components/About/Funds";
import Reviews from "../components/About/Reviews";
import Goals from "../components/About/Goals";
import Address from "../components/About/Address";
import Contact from "../components/About/Contact";
import History from "../components/About/History";

function About() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <WhoWe />
            <Funds />
            <Reviews />
            <Goals />
            <Address />
            <Contact />
            <History />
        </div>
    );
}

export default About;
